import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import VendorDetails from "./VendorDetails";
import PreferredItemsTab from "./PreferredItemsTab";
import PurchaseOrdersTab from "./PurchaseOrdersTab";
import PaymentsTab from "./PaymentsTab";
import AdditionalLocationsTab from "./AdditionalLocationsTab";
import CuModal from "../../common_component/component/CuModal";
import { toast } from "react-toastify";
import {
  useCreateItem,
  useUpdateItem,
} from "../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useAtom } from "jotai";
import { clinicAtom, pharmacyAtom } from "../../_helper/constant/constant-atom";

const VendorModal = ({ onClose, onSave, vendor, purchaseOrders, payments }) => {
  const [clinic] = useAtom(clinicAtom);
  const [pharmacy] = useAtom(pharmacyAtom);
  const [formData, setFormData] = useState({
    id: vendor?.id,
    vendor_name: vendor?.vendor_name || "",
    vendor_code: vendor?.vendor_code || "",
    type: vendor?.type || "Manufacturer",
    gstin: vendor?.gstin || "",
    pan: vendor?.pan || "",
    tin: vendor?.tin || "",
    cin: vendor?.cin || "",
    tan: vendor?.tan || "",
    msme: vendor?.msme || "",
    contact_person_name: vendor?.contact_person_name || "",
    contact_email: vendor?.contact_email || "",
    account_no: vendor?.account_number || "",
    ifsc: vendor?.ifsc || "",
    bank_name: vendor?.bank_name || "",
    branch_name: vendor?.branch_name || "",
    items_id: [],
  });

  const [activeTab, setActiveTab] = useState("details");

  const handleSaveDetails = (updatedDetails) => {
    setFormData((prev) => ({ ...prev, ...updatedDetails }));
  };

  const handleSavePreferredItems = (preferredItems) => {
    setFormData((prev) => ({ ...prev, preferredItems }));
  };

  const handleSaveLocations = (updatedLocations) => {
    setFormData((prev) => ({ ...prev, locations: updatedLocations }));
  };

  console.log("Form Data", formData);

  const handleValidation = () => {
    const errors = {};
    if (!formData.vendor_name) errors.vendor_name = "Vendor name is required.";
    if (!formData.gstin) errors.gstin = "GSTIN is required.";
    if (!formData.pan) errors.pan = "PAN is required.";
    return errors;
  };

  const mutation = useCreateItem(ApiEndPoint.INVENTORY);
  const update_mutation = useUpdateItem(ApiEndPoint.INVENTORY);

  console.log("Form Data", formData);

  const handleSubmit = () => {
    const errors = handleValidation();
    if (Object.keys(errors).length > 0) {
      toast.error("Please fix validation errors before submitting.");
      return;
    }
    if (formData.id) {
      update_mutation.mutate(
        {
          data: {
            action: "patchVendor",
            ...formData,
          },
        },
        {
          onSuccess: () => {
            toast.success("Vendor Details Updated!");
          },
        }
      );
    } else {
      mutation.mutate(
        {
          action: "postVendor",
          clinic_id: clinic.id,
          pharmacy_id: pharmacy.id ? pharmacy.id : null,
          ...formData,
        },
        {
          onSuccess: () => {
            onClose();
            toast.success("Vendor Added Succesfully!");
          },
        }
      );
      console.log("Form Data", formData);
    }

    // onSave(formData);
  };

  return (
    <CuModal closeModal={onClose}>
      <div className="bg-white rounded shadow-lg p-6 w-full max-w-6xl relative">
        <button
          className="absolute top-4 right-4 text-[#191919]"
          onClick={onClose}
        >
          <FiX size={20} />
        </button>
        <h2 className="text-xl font-bold mb-4">
          {vendor ? "Edit Vendor" : "Add New Vendor"}
        </h2>

        {/* Tabs Navigation */}
        {/* "items", "purchaseOrders", "payments", "locations" */}
        <div className="mb-4 border-b">
          {["details", "purchaseOrders"].map((tab) => (
            <button
              key={tab}
              className={`px-4 py-2 border-b-2 ${
                activeTab === tab
                  ? "border-[#c7eac9] text-[#662626]"
                  : "border-transparent text-gray-500"
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab === "details" && "Vendor Details"}
              {tab === "items" && "Preferred Items"}
              {tab === "purchaseOrders" && "Purchase Orders"}
              {tab === "payments" && "Payments"}
              {tab === "locations" && "Additional Locations"}
            </button>
          ))}
        </div>

        {/* Tabs Content */}
        <div className="mt-4">
          {activeTab === "details" && (
            <VendorDetails
              formData={formData}
              onSave={handleSaveDetails}
              setFormData={setFormData}
            />
          )}
          {activeTab === "items" && (
            <PreferredItemsTab
              preferredItems={formData.preferredItems}
              onSave={handleSavePreferredItems}
            />
          )}
          {activeTab === "purchaseOrders" && (
            <PurchaseOrdersTab purchaseOrders={purchaseOrders} />
          )}
          {activeTab === "payments" && <PaymentsTab payments={payments} />}
          {activeTab === "locations" && (
            <AdditionalLocationsTab
              locations={formData.locations}
              onSave={handleSaveLocations}
            />
          )}
        </div>

        {/* Save and Cancel Buttons */}
        <div className="flex justify-end gap-3 mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded bg-gray-300 text-[#191919] hover:bg-gray-400 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 rounded bg-[#c7eac9] text-[#191919] hover:bg-[#ebf8ec] transition font-medium"
          >
            Save
          </button>
        </div>
      </div>
    </CuModal>
  );
};

export default VendorModal;
